import { useQuery } from 'react-query';

import { apiLambda } from '../services/apiLambda';
import { api } from '../services/api';

const basePath = '/vehicle';

export interface IObjectDebt {
  grupo: any;
  valor: number;
  codigo: number;
  emissor: string;
  validade: string | Date;
  descricao: string;
  vencimento: string | Date;
  descricaoAdicional: string;
}

export interface IDataConsulta {
  uf: string;
  campos: [
    {
      codigo: number;
      conteudo: string;
    },
    {
      codigo: number;
      conteudo: string;
    },
  ];
  codigo: number;
  grupos: [
    {
      grupo: number;
      padrao: boolean;
      descricao: string;
      marcarGrupo: number[];
      desmarcarGrupo: [];
    },
  ];
  debitos: {
    ipva: IObjectDebt[];
    dpvat: IObjectDebt[];
    multas: IObjectDebt[];
    outros: IObjectDebt[];
    licenciamento: IObjectDebt[];
  };
}

export interface IVehicleInfo {
  id: number;
  sub: string;
  nickname: string;
  idVehicle: number;
  document: string;
  uf?: string;
  renavam?: string;
  chassi?: string;
  vehicleType?: string;
  showNotification: true;
  isSpecial: false;
  owner?: string;
  color?: string;
  fuelType?: string;
  model?: string;
  modelYear?: number;
  import_id?: number;
  fipe?: string;
  lastConsult: number;
  lastConsultAtDynamo: number;
  importId: any;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
  vehicle: {
    id: number;
    placa: string;
    renavam: string;
    uf: string;
    municipio: string;
    chassi: string;
    tipo: string;
    marca: string;
    ano: number;
    importado: boolean;
    invalid: boolean;
    licensingStatus: string;
    licensingExpirationDate: string;
    lastLicensed?: number;
    lastIPVA?: any;
    lastMultaConsult?: any;
    licensingPaymentDate?: any;
    created_at: Date;
    updated_at: Date;
    deleted_at?: string;
  };
  consult?: {
    id: number;
    totalDebts?: any;
    created_at: Date;
    updated_at: Date;
    deleted_at?: string;
    dataConsulta: IDataConsulta;
  };
  hasCrlvCoolDown?: false;
  driver?: {
    name: string;
  };
  fullTotalDebts?: number;
}

export interface IPagedParams {
  resultsPerPage?: number;
  page?: number;
  text?: string;
  uf?: string;
  hasDebts?: string;
  licensingStatus?: string;
  orderBy?: string;
  orderByDirection?: string;
  enabled?: boolean;
}

export interface IImportingStatus {
  failed: number;
  success: number;
  total: number;
  status: 'EM ANDAMENTO' | 'FINALIZADO';
}

export interface IGetUserVehiclePagedResult {
  results: IVehicleInfo[];
  nPages: number;
  total: number;
  resultsPerPage: string;
  currentPage: string;
}

export interface IMultipleDelete {
  removeIds: number[];
}

export async function listVehicleInfo(
  params: IPagedParams,
): Promise<IGetUserVehiclePagedResult> {
  const { data } = await api.get(`${basePath}/paged`, { params });

  return data.data.userVehicles;
}

export async function getUserVehicleById(id: number): Promise<any> {
  const { data } = await api.get(`${basePath}/${id}`);

  return data;
}

export async function deleteUserVehicle(id: number): Promise<any> {
  const data = await api.delete(`${basePath}-user/${id}`);
  return data;
}

export async function importVehicles(data: any[]): Promise<any> {
  return await api.post(`vehicle/import`, data, {
    headers: {
      terminal: process.env.REACT_APP_TERMINAL,
    },
  });
}

export async function getInProgressUserVehicles(): Promise<IImportingStatus[]> {
  const { data } = await apiLambda.get(`vehicle/import-status`);
  return data?.data;
}

export const deleteMultipleUserVehicle = async (
  data: IMultipleDelete,
): Promise<any> => {
  return await api.put(`/vehicle-user/delete-multiple`, data);
};

export function useVehicleInfo(params: IPagedParams) {
  params.orderByDirection = params.orderByDirection?.toUpperCase();
  const queryKey = [
    'VEHICLES',
    `${basePath}/paged`,
    params.orderByDirection,
    params.orderBy,
    params.text,
    params.uf,
    params.hasDebts,
    params.licensingStatus,
    params.page,
    params.resultsPerPage,
  ];

  return useQuery(queryKey, () => listVehicleInfo(params), {
    staleTime: 60000,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: params.enabled,
  });
}
